import { Vue } from 'vue-property-decorator';

Vue.filter('textAreaToHtml', (value : string) => {
    if (value) {
        return value.replaceAll("\n", "<br />");
    }
})

